var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.6.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 12.34 11.84)",
    id: "VRaXZyX4GNG0yr3p-V-Yn"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(107,70,236)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-12.34, -11.84)",
    d: "M 2.19496 14.6105 C 0.159544 16.6459 0.159544 19.9647 2.18679 21.992 C 4.22221 24.0274 7.541 24.0274 9.57642 21.992 L 14.1868 17.3816 C 16.1241 15.4443 16.2304 12.3462 14.4729 10.2944 C 14.1295 9.90205 13.4756 9.853 13.0832 10.18 C 12.6909 10.5233 12.6418 11.1773 12.9688 11.5696 C 14.0805 12.8612 14.0396 14.7658 12.8053 16.0001 L 8.19495 20.6105 C 6.9034 21.9021 4.85981 21.9021 3.56826 20.6105 C 2.28488 19.3271 2.28488 17.2835 3.57643 15.992 L 7.95789 11.6105 C 8.33392 11.2508 8.33392 10.5805 7.97424 10.2208 C 7.6064 9.853 6.9361 9.853 6.57643 10.229 L 2.19496 14.6105 Z M 10.5001 6.30532 C 8.55462 8.25082 8.44836 11.3489 10.214 13.3925 C 10.541 13.7849 11.2113 13.8339 11.5955 13.4988 C 11.9879 13.1718 12.0451 12.5097 11.7018 12.1173 C 10.5982 10.8339 10.6473 8.92112 11.8816 7.68679 L 16.4919 3.07643 C 17.7835 1.78488 19.8189 1.79305 21.1023 3.07643 C 22.3938 4.36799 22.402 6.40341 21.1105 7.69496 L 16.729 12.0764 C 16.353 12.4361 16.353 13.1064 16.7126 13.4661 C 17.0805 13.8339 17.7508 13.8339 18.1105 13.4579 L 22.4919 9.07644 C 24.5273 7.04101 24.5273 3.72221 22.4919 1.68679 C 20.4647 -0.340462 17.1459 -0.340461 15.1105 1.69496 L 10.5001 6.30532 Z",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkPurple);
export default __webpack_public_path__ + "static/media/link_purple.ef6c9f258893027eaacf36dc959d86a3.svg";
export { ForwardRef as ReactComponent };